import React from "react";
import Container from "../layout/Container";

const Add = () => {
  return (
    <Container>
      <div className="mb-[60px] flex items-center justify-center gap-x-6">
        <div className="rounded-md border-4 border-solid border-primary py-[53px] px-[122px] font-pop text-2xl font-medium text-black">
          Banners Ads
        </div>
        <div className="rounded-md border-4 border-solid border-primary py-[53px] px-[122px] font-pop text-2xl font-medium text-black">
          Banners Ads
        </div>
        <div className="rounded-md border-4 border-solid border-primary py-[53px] px-[122px] font-pop text-2xl font-medium text-black">
          Banners Ads
        </div>
      </div>
    </Container>
  );
};

export default Add;
